<acc-modal #leaveConfirm type="delete"
           [config]="modalLeaveConfig"
           [title]="'deactivate.dialog.leave.title'|translate"
           [body]="'deactivate.dialog.leave.body'|translate"
           (accConfirmed)="confirmed()"
           (accCanceled)="canceled()"
           (accClosed)="canceled()">
</acc-modal>

<acc-modal #waitDialog type="show" action="wait" footer="none"></acc-modal>
